/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M46.316 43.692l-11.35-11.863a19.462 19.462 0 004.513-12.444C39.479 8.684 30.829 0 20.231 0 9.598 0 .983 8.684.983 19.385c0 10.7 8.649 19.384 19.248 19.384 4 0 7.795-1.196 11.042-3.521l11.453 11.966a2.464 2.464 0 001.812.786c.65 0 1.265-.239 1.744-.718.957-.957.991-2.564.034-3.59zM20.231 33.675c-7.864 0-14.223-6.427-14.223-14.325 0-7.897 6.394-14.324 14.223-14.324s14.222 6.427 14.222 14.324c0 7.932-6.393 14.325-14.222 14.325z"/>'
}
